import 'babel-polyfill'

exports.onClientEntry = () => {
  // Don't need to do anything here, but if you don't
  // export something, the import won't work.
}



// WEBPACK FOOTER //
// ./gatsby-browser.js